import { render } from "./SwitchToggleButton.vue?vue&type=template&id=046484f8&scoped=true"
import script from "./SwitchToggleButton.vue?vue&type=script&lang=js"
export * from "./SwitchToggleButton.vue?vue&type=script&lang=js"

import "./SwitchToggleButton.vue?vue&type=style&index=0&id=046484f8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-046484f8"]])

export default __exports__